import React, { useMemo } from 'react';
import FormInput from 'components/Input/FormInput';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';

interface IVersionCodeField {
	changeVersionCode: (value: string) => void;
}

export const VersionCodeField: React.FC<IVersionCodeField> = React.memo(({ changeVersionCode }) => {
	const { t } = useTranslation('error');
	const { t: tForm } = useTranslation('form');

	const validationRules = useMemo<Rule[]>(
		() => [
			{ required: true, message: t('enterVersionCode') },
			{ max: 10, message: tForm('fieldCannotBeMoreThanCharactersLong', { count: 10 }) },
		],
		[t],
	);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const onlyDigits = e.target.value.replace(/\D/g, '');
		changeVersionCode(onlyDigits);
		return onlyDigits;
	};

	return (
		<FormInput
			testId="VersionCodeField"
			name="versionCode"
			label="versionCodeLabel"
			getValueFromEvent={handleChange}
			validationRules={validationRules}
		/>
	);
});
